import React, { useContext, useEffect, useState } from 'react'
import {
  AvailabilityPageContainer,
  ClinicWorkforcePageContainer,
} from './ClinicManageWorkforcePageStyles'
import ClinicHeader from '../ClinicHeader'
import { ClinicDataContext } from '../../../context/ClinicDataContext'
import { CSmartTable } from '@coreui/react-pro'
import { Chip, IconButton } from '@mui/material'
import Delete from '@mui/icons-material/Delete'
import Edit from '@mui/icons-material/Edit'
import { useNavigate, useParams } from 'react-router-dom'
import { GenericHeaderBackButton } from 'src/consumer/components/UserActivityPage/MyPlanComponents'
import { ClinicLocationStaffComponent } from 'src/clinic/views/onboardng/ClinicOnboardingComponents'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
import { postBPDataWithoutParams } from 'src/business/services'

export default function ClinicManageWorkforcePage() {
  const { clinicId, clinicBrandId } = useParams()
  const { ownerData, refreshOwnerAssociatedClinicsData } = useContext(ClinicDataContext)
  const navigate = useNavigate()

  const [loading, setLoading] = useState()
  const [staffObject, setStaffObject] = useState({ doctors: [], therapists: [], assistants: [] })

  const thisClinicData = {
    ...ownerData?.associatedClinicsData?.find((item) => item?.id === clinicId),
    apiParam: 'clinic-profile',
  }
  const thisClinicBrandData = ownerData?.associatedClinicBrandsData?.find(
    (item) => item?.id === clinicBrandId,
  )

  async function saveClinicBrandDetails() {
    setLoading(true)
    const toSubmitWithStaff = { ...thisClinicData, ...staffObject }
    const responseSaveProfile = await postBPDataWithoutParams(
      '/api/secure/cp/clinic/save',
      toSubmitWithStaff,
    )
    setLoading(false)
    if (
      responseSaveProfile?.status === 200 &&
      isCommonResponseSuccessful(responseSaveProfile?.data?.code) &&
      responseSaveProfile?.data?.data?.clinic
    ) {
      await refreshOwnerAssociatedClinicsData()
      navigate(`/clinic-home/${clinicBrandId}/${clinicId}`)
    } else {
      alert('Please try again')
    }
  }

  useEffect(() => {
    setStaffObject({
      doctors:
        ownerData?.associatedClinicsData?.find((item) => item?.id === clinicId)?.doctors || [],
      therapists:
        ownerData?.associatedClinicsData?.find((item) => item?.id === clinicId)?.therapists || [],
      assistants:
        ownerData?.associatedClinicsData?.find((item) => item?.id === clinicId)?.assistants || [],
    })
  }, [])

  // const [workforceItems, setWorkforceItems] = React.useState([])
  // async function Setup() {
  //   setWorkforceItems((prev) => {
  //     const dataToReturn = [
  //       ...(thisClinicData?.doctors || []).map((doc) => ({ ...doc, type: 'doctor' })),
  //       ...(thisClinicData?.therapists || []).map((doc) => ({ ...doc, type: 'therapist' })),
  //       ...(thisClinicData?.assistants || []).map((doc) => ({
  //         ...doc,
  //         type: 'clinic_assistant',
  //       })),
  //       ...(thisClinicData?.pharmacists || []).map((doc) => ({ ...doc, type: 'pharmacist' })),
  //       ...(thisClinicData?.management || []).map((doc) => ({ ...doc, type: 'management' })),
  //     ]

  //     return dataToReturn.map((data) => {
  //       return {
  //         ...data,
  //         email: data.email || null,
  //         mobile: data.mobile || null,
  //         status: data.status || null,
  //       }
  //     })
  //   })
  // }
  // function handleEdit() {}
  // function handleDelete() {}
  // useEffect(() => {
  //   Setup()
  // }, [])
  // useEffect(() => {
  //   console.log(workforceItems)
  // }, [workforceItems])

  return (
    <AvailabilityPageContainer>
      <ClinicHeader heading={`${thisClinicData?.name || thisClinicData?.title} | Workforce`} />
      <GenericHeaderBackButton
        clickfunction={() => window.history.back()}
        styles={{ margin: '20px' }}
      />
      <ClinicLocationStaffComponent
        staffObject={staffObject}
        setStaffObject={setStaffObject}
        saveStaffFunc={saveClinicBrandDetails}
        savingStaff={loading}
        peopleInThisBrandData={ownerData?.ownerBrandPeopleUserSummary?.[clinicBrandId]}
        mentorsInThisBrandData={ownerData?.ownerBrandMentorsData?.[clinicBrandId]}
        clinicParentBrandData={thisClinicBrandData}
      />
      {/* <ClinicWorkforcePageContainer>
        <CSmartTable
          columns={columns}
          items={workforceItems}
          scopedColumns={scopedColumns(handleEdit, handleDelete)}
          tableProps={{
            // hover: true,
            striped: true,
            responsive: true,
          }}
        />
      </ClinicWorkforcePageContainer> */}
    </AvailabilityPageContainer>
  )
}

// const columns = [
//   { key: 'type', label: 'Type' },
//   { key: 'email', label: 'Email' },
//   { key: 'mobile', label: 'Mobile' },
//   { key: 'status', label: 'Status' },
//   { key: 'actions', label: 'Actions' },
// ]

// function scopedColumns(handleEdit, handleDelete) {
//   return {
//     type: (item) => <td>{typeToLabel?.[item?.type]}</td>,
//     status: (item) => (
//       <td>
//         {item?.status === 'prospect' ? (
//           <Chip label="Pending Approval" sx={{ fontFamily: 'Outfit' }} color={'warning'} />
//         ) : (
//           <Chip label="Approved" sx={{ fontFamily: 'Outfit' }} color={'success'} />
//         )}
//       </td>
//     ),
//     actions: (item) => (
//       <td>
//         <IconButton onClick={() => handleEdit(item)}>
//           <Edit />
//         </IconButton>
//         <IconButton onClick={() => handleDelete(item)}>
//           <Delete />
//         </IconButton>
//       </td>
//     ),
//   }
// }

// const typeToLabel = {
//   doctor: 'Doctor',
//   therapist: 'Therapist',
//   clinic_assistant: 'Clinic Assistant',
//   pharmacist: 'Pharmacist',
//   management: 'Management',
// }
